
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 340 255","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M311 38h-25v-9h25v9zM25 38H0v138h25v54h290v-54h25v79H0V0h340v38h-25V25H25v13zm286 188h-25v-50h25v50zM54 38H29v-9h25v9zm0 188H29v-50h25v50z","fill":"#9D9D9D"}}),_c('path',{attrs:{"d":"M297 42v74h-11V42h11zm14 131h-11v-73h11v73zm-29 29v11H58v-11h224zM58 53V42h224v11H58zm-4-11v74H43V42h11zM40 173H29v-73h11v73z","fill":"#7000BD"}})])])
          )
        }
      }
    